import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SpecBackButton from "../../components/SpecBackButton";
import SpecSpinner from "../../components/SpecSpinner";
import useSpecRecipe from "../../hooks/useSpecRecipe";
import useSpecPartners from "../../hooks/useSpecPartners";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "react-query";
import inventoryClient from "../../clients/inventoryClient";
import CopySpecRecipeModal from "../../components/Modals/CopySpecRecipeModal";
import SpecRecipeForm from "./components/SpecRecipeForm";

const SpecRecipeDetails = () => {
  const navigate = useNavigate();
  const { recipeid: recipeId, establishmentid } = useParams();
  const { isLoading, data } = useSpecRecipe(recipeId);
  const { data: specPartnersData, isLoading: isLoadingSpecPartners } = useSpecPartners();
  const [copyModalOpen, setCopyModalOpen] = useState(false);

  const copySpecRecipeMutation = useMutation(inventoryClient.copySpecRecipe, {
    onSuccess: (result) => {
      navigate(`/spec/${establishmentid}/recipes/${result?.recipe?.id}`);
    },
  });

  const handleCopyRecipe = async (recipeId) => {
    await copySpecRecipeMutation.mutateAsync({
      establishmentId: establishmentid,
      recipeId: recipeId,
    });
  };

  if (isLoading || isLoadingSpecPartners) {
    return <SpecSpinner open text="Loading Recipe..." />;
  }

  const recipe = data?.recipe;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "2440px",
        padding: 4,
        marginTop: 6,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <SpecBackButton
          backText="Spec Recipes"
          onClick={() => navigate(`/spec/${establishmentid}/spec-recipes`)}
        />
        <Button
          variant="contained"
          onClick={() => setCopyModalOpen(true)}
          startIcon={<ContentCopyIcon />}
        >
          <Typography variant="largeButton">Copy to My Recipes</Typography>
        </Button>
      </Box>
      <SpecRecipeForm recipe={recipe} specPartners={specPartnersData?.specPartners} />
      <CopySpecRecipeModal
        copyRecipe={handleCopyRecipe}
        isOpen={copyModalOpen}
        toggleModalOpen={() => setCopyModalOpen(!copyModalOpen)}
        recipeName={recipe?.name}
        recipeId={recipe?.id}
      />
    </Box>
  );
};

export default SpecRecipeDetails;
